module.exports = "## What is different in Bulk Tool?\r\n\r\nBatch resize tool is designed to process multiple images at once. At this time, the bulk tool does not allow single image editing (crop, flip, rotate, and image filters)."


//////////////////
// WEBPACK FOOTER
// ./src/containers/BulkResize/what-is-different.md
// module id = 1138
// module chunks = 0